import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../shared/services/api/api.service';
import { IPagination } from '../../../shared/services/api/interface/pagination.interface';

@Injectable({
  providedIn: 'root',
})
export class LabmedService {
  constructor(private readonly apiService: ApiService) {}

  getLabmedCases(filters: any): Observable<IPagination> {
    return this.apiService.post<IPagination>('labmed/get-cases', {
      ...filters,
    });
  }

  sendToLabmed(data: any): Observable<{
    success: boolean;
    errors: { caseNo: string; errors: string[] }[];
  }> {
    return this.apiService.post<{
      success: boolean;
      errors: { caseNo: string; errors: string[] }[];
    }>('labmed/send-cases', {
      list: data,
    });
  }

  getLabmedLogsByCaseId(caseId: number) {
    return this.apiService.get<any>(`labmed/get-labmed-logs/${caseId}`);
  }

  sendLabmedReport(
    caseId: number,
    emails: string[] = []
  ): Observable<{ success: boolean }> {
    return this.apiService.post<{ success: boolean }>(`labmed/send-report`, {
      caseId,
      emails,
    });
  }
}
